export const biEvents = {
    startCourse: 100,
    courseVideoStarted: 101,
    courseVideoWatching: 102,
    courseVideoWhatchedHalf: 103,
    courseVideoFinished: 104,
    templateCta: 105,
    certificationPage: 110,
    webinarPageOpen: 117,
    webinarRsvp: 118,
    webinarVideoStarted: 119,
    webinarVideoWatching: 120,
    webinarVideoWhatchedHalf: 121,
    webinarVideoFinished: 122,
    startTutorial: 130,
    tutorialVideoStarted: 131,
    tutorialVideoWatching: 132,
    tutorialVideoWhatchedHalf: 133,
    tutorialVideoFinished: 134,
    pageOpen: 135,
    goToWix: 136,
    
}